import React, { Component } from 'react';
import MaxTruckPicture1 from '../Static/maxTruck/IMG_0612.jpg';
import MaxTruckPicture2 from '../Static/maxTruck/tow-hitch-w-trailer.jpg';
import {FormattedHTMLMessage} from "react-intl";
import ChangeLocale from "../Components/changeLocale";
import GoBack from "../Components/goBack";

class MaxTruck extends Component {
	render() {
		const { locale, changeLocale } = this.props;

		return (
			<>
				<GoBack />
				<ChangeLocale locale={locale} changeLocale={changeLocale} />
				<h2>MAX - Truck</h2>
				<div className='row justifyContent--center'>
					<img decoding="async" className='gallery-picture with-margin' src={MaxTruckPicture1} alt='muck-truck-max' />
					<img decoding="async" className='gallery-picture with-margin' src={MaxTruckPicture2} alt='muck-truck-max' />
				</div>

				<p>
					<FormattedHTMLMessage id='maxTruck' />
				</p>

				{/*<p>MAX Truck ™ dokáže odviezť až 365kg náklad a v pokoji ho vyvezie aj hore svahom s 30 ° sklonom plnom zaťažení, čo je viac ako štvornásobok toho čo odvezie bežný fúrik a vy sa nenarobíte.</p>*/}
				{/*<p>MAX Truck je preto vysoko odporúčaný z hľadiska zdravia a bezpečnosti, pretože značne zvyšuje produktivitu práce bez výraznej únavy obsluhy.</p>*/}
				{/*<p>Vyvážené rozloženie hmotnosti umožňuje ľahké vyklápanie.  MAX Truck  je vybavený parkovacou brzdou a zastaví sa pri uvoľnenej brzde,  v prípade pádu alebo zakopnutia obsluhy</p>*/}
				{/*<p>Stroje sú vybavené motormi Honda GXV Commercial triedy 5.5hp, ktoré ponúkajú výkonný systém pohonu všetkých štyroch kolies, čím zabezpečuje maximálnu trakciu pri pohybe nákladu na mokrom, sypkom alebo nerovnom teréne. K dispozícii je celý rad voliteľného príslušenstva.</p>*/}
				{/*<p>Hnacia náprava Tecumseh má 3 rýchlosti vpred a spiatočku. Je vybavený plynovou pákou, ktorá umožňuje presné riadenie rýchlosti jazdy.</p>*/}
			</>
		);
	}
}

export default MaxTruck;
